/**
 * Settings Module
 */
import {
    identificationTypes
} from './data'
import Vue from "vue";
import Soda from 'soda-js'
import Nprogress from "nprogress";

const state = {
    identificationTypes: identificationTypes,
    administrativoSidebar: null,
    sedes: null,
    snackbar: null,
    ambitosAtencion:[
        {id: 11, text: 'Ambulatorio – Priorizado'},
        {id: 12, text: 'Ambulatorio – No Priorizado'},
        {id: 21, text: 'Hospitalario – Domiciliario'},
        {id: 22, text: 'Hospitalario - Internación'},
        {id: 30, text: 'Urgencias'}
    ],
    serTecs: {
        nutricionales: [],
        complementarios: [],
        dispositivos: [],
    },
    tables: {
        tablePrescripciones: 0,
        tablePrescripcionesVersion: 4,
        tableDireccionamientos: 0,
        tableDireccionamientosVersion: 5,
        tableProgramaciones: 0,
        tableProgramacionesVersion: 7,
        tableEntregas: 0,
        tableEntregasVersion: 7,
        tableReportesEntrega: 0,
        tableReportesEntregaVersion: 7,
        tableFacturacion: 0,
        tableFacturacionVersion: 7
    },
    estadoCartera: ''
}

// getters
const getters = {
    estadoCartera (state) {
        return state.estadoCartera
    },
    getSedes(state) {
        return state.sedes
    },
    getNutricionales (state) {
        return state.serTecs.nutricionales
    },
    getComplementarios (state) {
        return state.serTecs.complementarios
    },
    getDispositivos (state) {
        return state.serTecs.dispositivos
    }
}

// actions
const actions = {
    getComplements(context) {
        context.dispatch('getSedes')
        context.dispatch('getSerTec', 'prodnutricionales')
        context.dispatch('getSerTec', 'prodcomplementarios')
        context.dispatch('getSerTec', 'tipdispositivos')
    },
    getSedes(context) {
        Vue.axios.get(`sedes`)
            .then(response => {
                context.commit('getSedes', response.data)
            }).catch(e => {
            context.commit('snackbar', {color: 'error', message: `al recuperar las sedes`, error: e})
            reject(e)
        })
    },
    getFacturas (context) {
        context.state.estadoCartera = ''
        Vue.axios.get('cartera')
            .then(response => {
                context.commit('assignEstadoCartera', response.data.detalle)
            }).catch(() => {
            console.log('No se pudo consultar el estado de sus facturas')
        })
    },
    async getSerTec(context, url) {
        Vue.axios.get(url)
            .then(response => {
                context.commit('getSerTec', {data: response.data, url: url})
            }).catch(e => {
            context.commit('snackbar', {color: 'error', message: `al recuperar los servicios y/o tecnologías`, error: e})
        })
    },
    async getCUMs(context, parametro) {
        let param = !parametro ? this.searchCUM.split('-') : parametro.split('-')
        let cums1 = await new Promise((resolve1, reject1) => {
            context.dispatch('apiCums', {param: param, resource: 'i7cb-raxc'}).then(result => resolve1(result)).catch(e => reject1(e))
        })
        let cums2 = await new Promise((resolve2, reject2) => {
            context.dispatch('apiCums', {param: param, resource: 'vgr4-gemg'}).then(result => resolve2(result)).catch(e => reject2(e))
        })
        console.log('el cums2', cums2)
        let rowsTotal = cums1.concat(cums2).sort((a, b) => a.expediente - b.expediente).sort((a, b) => a.consecutivocum - b.consecutivocum)
        return (param[1] ? rowsTotal.filter(x => x.consecutivocum.search(param[1]) !== -1) : rowsTotal)
    },
    apiCums (context, params) {
        return new Promise((resolve, reject) => {
            let urlComplement = isNaN(Number(params.param[0])) ? `descripcioncomercial like "%${params.param[0].toUpperCase()}%" OR principioactivo like "%${params.param[0].toUpperCase()}%"` : `expediente = ${params.param[0]}`
            const config = {
                hostDomain: 'datos.gov.co',
                resource: params.resource
            }
            const api = new Soda.Consumer(config.hostDomain)
            api.query()
                .withDataset(config.resource)
                .limit(50)
                .where(urlComplement)
                .getRows()
                .on('success', (rows) => {
                    resolve(rows)
                })
                .on('error', (error) => {
                    reject(error)
                })
        })
    },
    async getCUPS(context, parametro) {
        return new Promise((resolve, reject) => {
            Vue.axios.get(`cups/${parametro}`)
                .then(response => {
                    resolve(response.data)
            }).catch( error => {
                reject(error)
            })
        })
    },
    async searchCUPS(context, parametro) {
        return new Promise((resolve, reject) => {
            Vue.axios.get(`cups?filter[search]=${parametro}`)
                .then(response => {
                    resolve(response.data)
                }).catch( error => {
                reject(error)
            })
        })
    }
}

// mutations
const mutations = {
    assignEstadoCartera (state, facturas) {
        let vencidas = 0
        let hoy = Vue.prototype.moment()
        facturas.filter(z => (z.saldo > 0) && (z.fecha_vencimiento || z.estado === 'Activa')).forEach(x => {
            let fechaFactura = Vue.prototype.moment(x.fecha_vencimiento || x.fecha).add(x.fecha_vencimiento ? 1 : 16, 'days')
            if (fechaFactura.diff(hoy) < 0) vencidas++
        })
        state.estadoCartera = vencidas ? `Su cuenta registra ${vencidas} factura${vencidas === 1 ? '' : 's'} en mora... el servicio puede ser suspendido en cualquier momento.` : ''
    },
    showAdministrativoSidebar(state, show = true) {
        state.administrativoSidebar = show
    },
    reloadTable(state, table) {
        state.tables[table] = state.tables[table] + 1
    },
    getSedes(state, sedes) {
        state.sedes = sedes
    },
    getSerTec(state, data) {
        switch (data.url) {
            case 'prodnutricionales':
                state.serTecs.nutricionales = data.data
                break
            case 'prodcomplementarios':
                state.serTecs.complementarios = data.data
                break
            case 'tipdispositivos':
                state.serTecs.dispositivos = data.data
                break
        }
    },
    snackbar (state, data) {
        let timeout = 8000
        let message = ''
        if (data.error) {
            console.log('el error', data.error.response)
            if (data.error.response) {
                if (data.error.response.status === 401 || data.error.response.status === 412) {
                    data.color = 'warning'
                    if (data.error.response.status === 401) message = 'La sesión ha expirado, por favor ingresar nuevamente las credenciales se usuario.'
                    if (data.error.response.status === 412) {
                        if (localStorage.getItem('user')) {
                            message = 'Sabemos que eres tu, pero necesitamos confirmar tu contraseña.'
                        } else {
                            message = 'No estamos seguros de quien eres, por favor ingresa el usuario y contraseña.'
                        }
                    }
                } else {
                    if (data.error.response && data.error.response.data && data.error.response.data.errors) {
                        let errorList = data.error.response.data.errors
                        let items = []
                        errorList && Object.values(errorList).forEach((value, index) => {
                            items.push((index + 1) + `: ${value}`)
                        })
                        timeout = Object.keys(errorList).length * timeout
                        message = (`Hay ${Object.keys(errorList).length} ${Object.keys(errorList).length !== 1 ? 'errores' : 'error'}${data.message} <br> ${items.join('<br>')}`)
                    } else if (data.error.response && data.error.response.data && (data.error.response.data.error || (data.error.response.data.message))) {
						if(typeof data.error.response.data.message === 'string') {
							message = `Hay un error ${data.message} => ${data.error.response.data.error ? data.error.response.data.error : data.error.response.data.message} `
						} else if (typeof data.error.response.data.message && data.error.response.data.message.Errors && data.error.response.data.message.Errors.length) {
							message = data.error.response.data.message.Errors[0]
						}
                    } else {
                        message = `Hay un error ${data.message} => ${data.error.response.status}: ` + (data.error.response.data && data.error.response.data.message && data.error.response.data.message.Message ? data.error.response.data.message.Message : data.error.response.statusText)
                    }
                }
            } else {
                message = `Hay un error ${data.message}.`
            }
        } else {
            message = data.message
        }
        state.snackbar = {
            timeout: timeout,
            message: message,
            color: data.color
        }
    }
}

export default {
	state,
	getters,
	actions,
	mutations
}
